import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LoginComponent } from './pages/login/login.component';
import { FormsModule } from '@angular/forms';
import { RecuperarSenhaComponent } from './pages/recuperar-senha/recuperar-senha.component';
import { EscritoriosComponent } from './pages/cadastros/escritorios/escritorios.component';
import { DataTablesModule } from 'angular-datatables';
import { AlterarSenhaComponent } from './pages/alterar-senha/alterar-senha.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { ColaboradoresComponent } from './pages/cadastros/colaboradores/colaboradores.component';
import { NgSelect2Module } from 'ng-select2';
import { ExtracoesComponent } from './pages/extracoes/extracoes.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserService } from './services/user.service';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { DctfComponent } from './pages/exportacoes/dctf/dctf.component';
import { EfdComponent } from './pages/exportacoes/efd/efd.component';
import { EcdComponent } from './pages/exportacoes/ecd/ecd.component';
import { EcfComponent } from './pages/exportacoes/ecf/ecf.component';
import { IcmsComponent } from './pages/exportacoes/icms/icms.component';
import { PagamentoIndevidoMaiorComponent } from './pages/dcomp/pagamento-indevido-maior/pagamento-indevido-maior.component';
import { NfeComponent } from './pages/importacoes/nfe/nfe.component';
import { CteComponent } from './pages/importacoes/cte/cte.component';
import { CfeComponent } from './pages/importacoes/cfe/cfe.component';
import { IefdComponent } from './pages/importacoes/iefd/iefd.component';
import { IecfComponent } from './pages/importacoes/iecf/iecf.component';
import { IecdComponent } from './pages/importacoes/iecd/iecd.component';
import { IicmsComponent } from './pages/importacoes/iicms/iicms.component';
import { IdctfComponent } from './pages/importacoes/idctf/idctf.component';
import { RessarcimentoComponent } from './pages/dcomp/ressarcimento/ressarcimento.component';
import { Home2Component } from './pages/home2/home2.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BoardService } from './services/board.service';
import { TagsComponent } from './pages/cadastros/tags/tags.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { BlockUIModule } from 'ng-block-ui';
import { ConfiguracoesComponent } from './pages/configuracoes/configuracoes.component';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateCustomParserFormatter } from "./services/date-formatter.service";
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { AnalisesComponent } from './pages/analises/analise/analises.component';
import { ChatComponent } from './pages/chat/chat.component';
import { ConhecimentoComponent } from './pages/conhecimento/conhecimento.component';
import { DownloadsComponent } from './pages/downloads/downloads.component';
import { DashboardDevComponent } from './pages/dashboard-dev/dashboard-dev.component';

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null as any;

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    LoginComponent,
    RecuperarSenhaComponent,
    EscritoriosComponent,
    AlterarSenhaComponent,
    ColaboradoresComponent,
    ExtracoesComponent,
    DctfComponent,
    EfdComponent,
    EcdComponent,
    EcfComponent,
    IcmsComponent,
    PagamentoIndevidoMaiorComponent,
    NfeComponent,
    CteComponent,
    CfeComponent,
    IefdComponent,
    IecfComponent,
    IecdComponent,
    IicmsComponent,
    IdctfComponent,
    RessarcimentoComponent,
    Home2Component,
    TagsComponent,
    ConfiguracoesComponent,
    AnalisesComponent,
    ChatComponent,
    ConhecimentoComponent,
    DownloadsComponent,
    DashboardDevComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    DataTablesModule,
    NgxMaskModule.forRoot(),
    NgSelect2Module,
    HttpClientModule,
    DragDropModule,
    ColorPickerModule,
    BlockUIModule.forRoot(),
    NgbModule
  ],
  providers: [
    UserService,
    BoardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
